import React, { useState, forwardRef, useImperativeHandle } from 'react';
import clsx from 'clsx';
import { changePasswordAsync } from 'components/profile/ProfileService';
import { Modal, OpPasswordBox } from 'op2mise-react-widgets';
import { validateSecurityForm } from './securityForm.helper';
import styles from '../../UserProfile.module.css';

export const SecurityForm = forwardRef(({ setIsDirty }, ref) => {
  const [data, setData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const pristineData = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  };

  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');

  useImperativeHandle(ref, () => ({
    save: async () => {
      setApiError('');
      if (!validateSecurityForm(data, setErrors)) return false;

      try {
        await changePasswordAsync(data);
        setData(pristineData);
        return true;
      } catch (error) {
        setApiError(
          error?.response?.data?.message || 'Failed to change password',
        );
        return false;
      }
    },
    reset: () => {
      setData(pristineData);
      setErrors({});
      setApiError('');
    },
  }));

  const handleChange = (field, value) => {
    setData((prev) => ({ ...prev, [field]: value }));
    setIsDirty(true);
    setErrors((prev) => ({ ...prev, [field]: '' }));
    setApiError('');
  };

  return (
    <div className={clsx(styles.formContent, 'container')}>
      <div className={styles.sectionHeader}>Password Reset</div>
      <hr className={styles.hrLine} />

      <div className="row gx-2 mb-3">
        <div className="col-12 col-md-6">
          <OpPasswordBox
            errorMessage={errors.oldPassword}
            label="Old Password"
            onChange={(val) => handleChange('oldPassword', val)}
            value={data.oldPassword}
          />
        </div>
      </div>
      <div className="row gx-2 mb-3">
        <div className="col-12 col-md-6">
          <OpPasswordBox
            enableStrongPasswordValidation
            errorMessage={errors.newPassword}
            label="New Password"
            onChange={(val) => handleChange('newPassword', val)}
            value={data.newPassword}
          />
        </div>
      </div>
      <div className="row gx-2 mb-3">
        <div className="col-12 col-md-6">
          <OpPasswordBox
            errorMessage={errors.confirmPassword}
            label="Confirm New Password"
            onChange={(val) => handleChange('confirmPassword', val)}
            value={data.confirmPassword}
          />
          <small
            className="text-muted"
            style={{ fontSize: '11px', marginTop: '4px', display: 'block' }}
          >
            Must match the new password entered above.
          </small>
        </div>
      </div>

      {apiError && (
        <Modal
          children={
            <p
              className="content-emphasized"
              style={{ fontSize: '16px', textAlign: 'center' }}
            >
              {apiError}
            </p>
          }
          handleOnClose={() => setApiError('')}
        />
      )}
    </div>
  );
});
